module.exports = __webpack_public_path__ + "static/media/oberflex-pinanoeudst101-2560x1440.24f5e24c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-pinanoeudst101-2560x1440.jpg
// module id = 1051
// module chunks = 37